var poll_default = {
  "fontElementMap": "BbGGF",
  "container": "jfl1g",
  "fullscreen": "Sg25J",
  "background_overlay": "m7C8G",
  "with_image": "N2cfa",
  "options": "myz1v",
  "webview": "OM0Fn",
  "grid": "uUQ7t",
  "option": "_9o-zx",
  "cta_button": "LBMqI",
  "add_option": "RAd9c",
  "see_more": "dkGYf",
  "list": "bh6QU",
  "column": "EY2J1",
  "additional_note": "w4mkU",
  "spinner": "jHk60",
  "spin": "CtmGs",
  "shown": "GCPt2",
  "error": "NjWhp"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
